import * as angular from "angular";
import {$accountFactory} from "../$account.factory";

angular
  .module('bringoz.admin.accounts')
  .filter('accountName', AccountName);

function AccountName($account: $accountFactory) {
  return function (id) {
    if (!id) {
      return;
    }
    const val = $account(id).$value();
    return val ? val.name : '';
  }
}

